// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"279":"component---src-pages-index-jsx","834":"94726e6d"}[chunkId] || chunkId) + "-" + {"279":"e18c452b72c8e88a405e","454":"7d344ef6e6b54e9d26a2","834":"e75cbf828511e1efa3fb"}[chunkId] + ".js";
};